import type { Bank } from '@src/backend/src/common/data/banks';

export const bankNames = {
  alianza: {
    name: 'Alianza Fiduciaria',
  },
  santander: {
    name: 'Banco Santander Colombia',
  },
  coofinep: {
    name: 'COOFINEP',
  },
  avvillas: {
    name: 'Banco AV Villas',
  },
  cotrafa: {
    name: 'Cotrafa',
  },
  movii: {
    name: 'MOVii',
  },
  dale: {
    name: 'Dale!',
  },
  confiar: {
    name: 'Confiar',
  },
  union: {
    name: 'Banco Union (antes Giros)',
  },
  rappipay: {
    name: 'RappiPay',
  },
  nequi: {
    name: 'Nequi',
  },
  bancoagrario: {
    name: 'Banco Agrario',
  },
  bancoomeva: {
    name: 'Bancoomeva',
  },
  bancamia: {
    name: 'Bancamía',
  },
  coopcentral: {
    name: 'Banco Cooperativo Coopcentral',
  },
  citibank: {
    name: 'Citibank',
  },
  lulo: {
    name: 'Lulo Bank',
  },
  bancodeoccidente: {
    name: 'Banco de Occidente',
  },
  falabella: {
    name: 'Banco Falabella',
  },
  bancodebogota: {
    name: 'Banco de Bogotá',
  },
  bancocajasocial: {
    name: 'Banco Caja Social',
  },
  serfinanza: {
    name: 'Banco Serfinanza',
  },
  cfa: {
    name: 'Cooperativa Financiera de Antioquia',
  },
  coltefinanciera: {
    name: 'Coltefinanciera',
  },
  pichincha: {
    name: 'Banco Pichincha',
  },
  iris: {
    name: 'IRIS',
  },
  ban100: {
    name: 'Ban100 (antes Credifinanciera)',
  },
  bancopopular: {
    name: 'Banco Popular',
  },
  daviplata: {
    name: 'DaviPlata',
  },
  bancolombia: {
    name: 'Bancolombia',
  },
  finandina: {
    name: 'Banco Finandina',
  },
  scotiabankcolpatria: {
    name: 'DAVIbank',
  },
  gnbsudameris: {
    name: 'GNB Sudameris',
  },
  itau: {
    name: 'Banco Itaú',
  },
  bbva: {
    name: 'BBVA Colombia',
  },
  davivienda: {
    name: 'Davivienda',
  },
  mibanco: {
    name: 'Mibanco',
  },
  multibank: {
    name: 'Multibank',
  },
  mundomujer: {
    name: 'Mundo Mujer',
  },
  procreditcolombia: {
    name: 'Procredit Colombia',
  },
  bancow: {
    name: 'Banco W',
  },
  bancoldex: {
    name: 'Bancóldex',
  },
  juriscoop: {
    name: 'Financiera Juriscoop',
  },
  itauhelm: {
    name: 'Itaú (Helm Bank)',
  },
  jpmorgancolombia: {
    name: 'JP Morgan Colombia',
  },
  asopagos: {
    name: 'Asopagos',
  },
  pibank: {
    name: 'Pibank',
  },
  jfk: {
    name: 'JFK Cooperativa Financiera',
  },
  ding: {
    name: 'DING',
  },
  uala: {
    name: 'Ualá',
  },
  btgpactual: {
    name: 'BTG Pactual',
  },
  powwi: {
    name: 'Powwi',
  },
  bold: {
    name: 'Bold',
  },
  coink: {
    name: 'Coink',
  },
  santanderconsumer: {
    name: 'Santander Consumer',
  },
  global66: {
    name: 'Global66',
  },
  crezcamos: {
    name: 'Crezcamos',
  },
  nu: {
    name: 'Nu',
  },
  accion: {
    name: 'Accion Fiduciaria',
  },
  paycash: {
    name: 'PayCash',
  },
  contactar: {
    name: 'Banco Contactar',
  },
} as const satisfies Record<Bank, { name: string }>;

export const pseBanks = [
  'alianza',
  'santander',
  // "coofinep",
  'avvillas',
  'cotrafa',
  'movii',
  'dale',
  'confiar',
  'union',
  'rappipay',
  'nequi',
  'bancoagrario',
  'bancoomeva',
  'bancamia',
  'coopcentral',
  'citibank',
  'lulo',
  'bancodeoccidente',
  'falabella',
  'bancodebogota',
  'bancocajasocial',
  'serfinanza',
  'cfa',
  'coltefinanciera',
  'pichincha',
  'iris',
  'ban100',
  'bancopopular',
  'daviplata',
  'bancolombia',
  'finandina',
  'scotiabankcolpatria',
  'gnbsudameris',
  'itau',
  'bbva',
  'davivienda',
  // "mibanco",
  // "multibank",
  'mundomujer',
  // "procreditcolombia",
  // "bancow",
  // "bancoldex",
  'juriscoop',
  // "itauhelm",
  'jpmorgancolombia',
  // "asopagos",
  // "pibank",
  'jfk',
  'ding',
  'uala',
  // "btgpactual",
  'powwi',
  'bold',
  'coink',
  // "santanderconsumer",
  'global66',
  'crezcamos',
  'nu',
  'accion',
  'paycash',
  'contactar',
] as const satisfies Bank[];
export type PseBank = (typeof pseBanks)[number];
